export const categories = [
  {
    id: "gouwu-youhui",
    name: "购物优惠",
    slug: "gouwu-youhui",
    description: "汇集各大电商平台优惠券、促销活动、限时折扣等购物福利，帮你省钱买好物。",
    icon: "ri-shopping-bag-3-line",
    color: "accent",
    articleCount: 28,
  },
  {
    id: "huiyuan-quanyi",
    name: "会员权益",
    slug: "huiyuan-quanyi",
    description: "整理视频、音乐、阅读、云存储等各大平台会员权益与领取攻略，最大化你的会员价值。",
    icon: "ri-vip-crown-line",
    color: "primary",
    articleCount: 35,
  },
  {
    id: "shenghuo-butie",
    name: "生活补贴",
    slug: "shenghuo-butie",
    description: "涵盖出行补贴、餐饮优惠、住房福利、医疗健康等日常生活各类补贴信息汇总。",
    icon: "ri-heart-pulse-line",
    color: "secondary",
    articleCount: 22,
  },
  {
    id: "zhichang-fuli",
    name: "职场福利",
    slug: "zhichang-fuli",
    description: "聚焦企业员工福利政策、五险一金解读、年终奖攻略、培训补贴等职场相关内容。",
    icon: "ri-briefcase-4-line",
    color: "accent",
    articleCount: 19,
  },
  {
    id: "mianfei-shiyong",
    name: "免费试用",
    slug: "mianfei-shiyong",
    description: "搜罗软件工具、在线课程、电子书、生活服务等各类免费试用资源，先体验再决定。",
    icon: "ri-gift-2-line",
    color: "primary",
    articleCount: 31,
  },
  {
    id: "jifen-duihuan",
    name: "积分兑换",
    slug: "jifen-duihuan",
    description: "整理运营商积分、信用卡积分、电商积分等兑换攻略，让你的积分发挥最大价值。",
    icon: "ri-exchange-dollar-line",
    color: "secondary",
    articleCount: 16,
  },
  {
    id: "xuesheng-fuli",
    name: "学生福利",
    slug: "xuesheng-fuli",
    description: "专为学生群体整理的教育优惠、学生折扣、校园权益等专属福利资源。",
    icon: "ri-graduation-cap-line",
    color: "accent",
    articleCount: 24,
  },
  {
    id: "jieri-huodong",
    name: "节日活动",
    slug: "jieri-huodong",
    description: "春节、双十一、618、中秋等各大节日活动福利汇总，不错过任何一个薅羊毛的机会。",
    icon: "ri-fire-line",
    color: "primary",
    articleCount: 18,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};